import React, { useRef } from 'react';
import { CONSOLE_HEADER_SECTION_ELEMENT_ID } from 'src/commons/constants';
import { useIsMobile } from '@amzn/storm-ui';
import { PAGE_LAYOUT_TYPE } from 'src/app/slice';
import {
  useLayoutResizeObserver,
  usePageHeaderLayout,
} from 'src/commons/hooks';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';
import { ConnectedConsoleLevelBannerWithAces } from './components/Banners/Common/BannerWithAces';
import MobileBreadcrumb from './components/BreadcrumbIA2/MobileBreadcrumb';
import { ConnectedPageHeader } from './components/PageHeader/PageHeader';
import SkipNavCard from './components/SkipNavCard/SkipNavCard';
import MobileSpoofingInfo from './components/SpoofingInfo/MobileSpoofingInfo';
import { GlobalStyle, StickyMobileHeader } from './styles';
import { ToastBannerWrapper } from './UtilityComponents';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';

export const WebviewHeader: React.VFC<{
  pageLayoutType: PAGE_LAYOUT_TYPE;
  isSpoofing: boolean;
}> = ({ pageLayoutType, isSpoofing }) => {
  const chromeConfig = useChromeConfigContext();

  const consoleHeaderSectionRef = useRef<HTMLDivElement>(null);
  const pageHeaderSection = useRef<HTMLDivElement>(null);
  const breadcrumbs = chromeConfig?.breadcrumbs || [];
  const isFocusLayout =
    pageLayoutType === PAGE_LAYOUT_TYPE.FOCUS ||
    pageLayoutType === PAGE_LAYOUT_TYPE.FOCUS_NO_HEADER;
  const breadcrumb =
    breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1] : null;
  useLayoutResizeObserver({ consoleHeaderSectionRef });
  usePageHeaderLayout(pageHeaderSection);
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const { isInterstitialPage } = internalChromeConfig;
  const isMobile = useIsMobile();

  return (
    <>
      <GlobalStyle
        shouldShiftAppWrapper={false}
        isInterstitialPage={isInterstitialPage}
        isMobile={isMobile}
      />
      <SkipNavCard />
      <StickyMobileHeader
        id={CONSOLE_HEADER_SECTION_ELEMENT_ID}
        ref={consoleHeaderSectionRef}
      >
        <ConnectedConsoleLevelBannerWithAces />
        {isSpoofing && <MobileSpoofingInfo />}
      </StickyMobileHeader>
      <div ref={pageHeaderSection}>
        {!isFocusLayout && breadcrumb && (
          <MobileBreadcrumb breadcrumb={breadcrumb} />
        )}
        <ConnectedPageHeader />
      </div>
      <ToastBannerWrapper isMobile={true} />
    </>
  );
};
